import { useState } from 'react';
import { Grid } from '@zillow/constellation';
import ConnectedLeasesModule from '../ConnectedLeasesModule';
import ConnectedPropertyConditionModule from '../ConnectedPropertyConditionModule';

// TODO: do not call ConnectedPropertyConditionModule
// sometimes I am getting an error, Feature is not supported for this listing
const ConnectedLeaseAndPropertyConditionModule = () => {
  const [isLeasePresent, setIsLeasePresent] = useState(true);

  return (
    <Grid display="grid" gridTemplateColumns="repeat(12, minmax(0,1fr))" gap={{ xl_gte: 'sm' }}>
      <Grid data-testid="LeaseColumn" gridColumn={{ default: '1/13', xl_gte: '1/8' }}>
        <ConnectedLeasesModule setIsLeasePresent={setIsLeasePresent} />
      </Grid>
      <Grid
        data-testid="PropertyConditionColumn"
        gridColumn={{ default: '1/13', xl_gte: '8/13' }}
        gridRowStart={{ default: '2', xl: 'inherit' }}
        marginBottom={{ default: 'sm' }}
        marginTop={{ default: 0, lg_lte: 'sm' }}
      >
        <ConnectedPropertyConditionModule />
      </Grid>
    </Grid>
  );
};

export default ConnectedLeaseAndPropertyConditionModule;
